export const getSubscriber = async (u: string) => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      pragma: 'no-cache',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env.REACT_APP_REVENUE_CAT_KEY}`,
    },
  };

  const subscriber = await fetch(`https://api.revenuecat.com/v1/subscribers/${u}`, options)
    .then((response) => response.json())
    .then((response) => response.subscriber)
    // eslint-disable-next-line no-console
    .catch((err) => console.error(err));

  return subscriber;
};

// export const getSubscriptionInfo = async (uid: string) => {
//   const subscriber = await getSubscriber(uid);

//   // eslint-disable-next-line no-console
//   console.log(subscriber);

//   let hasPremium = false;
//   let timestamp = null;
//   let premiumEnd = null;

//   const isNew = checkIsEmpty(subscriber.entitlements);

//   if (!isNew) {
//     premiumEnd = subscriber.entitlements.premium.expires_date;
//     timestamp = new Date(premiumEnd).getTime();
//     hasPremium = timestamp > Date.now();
//   }

//   return {
//     isNewSubscriber: isNew,
//     hasPremium,
//     subscriptionEnd: timestamp,
//   };
// };

export const getSubscriptionInfo = async (email: string) => {
  const data = {
    email,
  };

  const subscription = await fetch('/.netlify/functions/get-subscription-status', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((r) => r);

  const dateEndMs = subscription.dateEnd * 1000;
  const hasPremium = subscription.dateEnd && dateEndMs > Date.now();
  const { isCanceled, plan, isNewCustomer, subscriptionAfterTrail } = subscription;

  return {
    isNewSubscriber: isNewCustomer,
    hasPremium,
    subscriptionEnd: dateEndMs,
    isCanceled,
    plan,
    subscriptionAfterTrail,
  };
};
